// extracted by mini-css-extract-plugin
module.exports = {"root":"TryToSearch_root__TgA99","label":"TryToSearch_label__gIqOS","list":"TryToSearch_list__a8ftK","suggestionButton":"TryToSearch_suggestionButton__yjYPY"};